import { jointParamsToStr } from '@autobest-ui/utils';
/**
 * @param url
 * @param params
 */
export function ajax(url, params) {
  try {
    new Image().src = "".concat(url).concat(jointParamsToStr(params));
  } catch (e) {}
}
export function sendBeacon(url, params) {
  var search = jointParamsToStr(params);
  if (window.navigator && window.navigator.sendBeacon) {
    window.navigator.sendBeacon("".concat(url).concat(search), '');
    return;
  }
  new Image().src = "".concat(url).concat(search);
}